export const checkIfInterviewInEvent = (interviewType, testEvent) => {
  if (!testEvent) {
    return false;
  }

  if (interviewType === "videoInterview") {
    return (
      testEvent.get("videoInterviews") || testEvent.get("videoInterviewId")
    );
  }

  if (interviewType === "liveInterview") {
    return testEvent.get("liveInterviews") || testEvent.get("liveInterviewId");
  }
};

export const getPendingEventsActionPermissions = (
  fromInvited,
  moveEmailCandidatesPermission,
  tests,
  candidate,
  testEvent,
  isInsightUser,
  isLiveInterviewEvent
) => {
  // LI event only has the 'Delete' action available
  if (isLiveInterviewEvent) {
    return {
      showRemind: false,
      showExtendExpiration: false,
      showCopy: false,
      showDelete: fromInvited && moveEmailCandidatesPermission,
      showRelease: false,
      showAdjustVideoInterview: false,
    };
  }

  const hasVideoInterviewInEvent = checkIfInterviewInEvent(
    "videoInterview",
    testEvent
  );

  // to determine if the Release Scores button needs to be displayed, we have to determine if at
  // least one test has been completed
  let hasCompletedTest = false;
  if (!fromInvited && moveEmailCandidatesPermission && tests) {
    tests.forEach((test) => {
      if (test.get("finished") === 1) {
        hasCompletedTest = true;
        return false;
      }
    });
  }

  let expirationDate = "";
  let hasEventExpiration = false;
  if (testEvent) {
    expirationDate = testEvent.get("eventExpirationDate");
    hasEventExpiration = expirationDate !== null;
  }

  // Do not show Release Scores option if VI is in the same event
  const showReleaseScoresOption =
    !fromInvited &&
    !hasVideoInterviewInEvent &&
    !isInsightUser &&
    moveEmailCandidatesPermission &&
    (hasCompletedTest ||
      candidate.get("applicationAvailable") ||
      candidate.get("resumeAvailable") ||
      candidate.get("documentAvailable"));

  const ifExpirationDatePassed =
    expirationDate && new Date() - new Date(expirationDate) > 0;

  const showAdjustVideoInterviewOption =
    hasVideoInterviewInEvent && (!ifExpirationDatePassed || !expirationDate);

  return {
    showRemind: moveEmailCandidatesPermission,
    showExtendExpiration: moveEmailCandidatesPermission && hasEventExpiration,
    showCopy: true,
    showDelete: fromInvited && moveEmailCandidatesPermission,
    showRelease: showReleaseScoresOption,
    showAdjustVideoInterview: showAdjustVideoInterviewOption,
  };
};
